<app-property-division-form [cnpjSeller]="false"></app-property-division-form>
